import { useState, useCallback } from 'react';

/**
 * Controla a visibilidade (mostrar/ocultar senha) de um ou mais campos.
 * @param {string[]} fields - nomes dos campos a controlar
 * @returns {{ visibility: Object, toggleVisibility: (field: string) => void }}
 */
export default function usePasswordVisibility(fields = []) {
  const [visibility, setVisibility] = useState(() =>
    fields.reduce((acc, field) => ({ ...acc, [field]: false }), {}),
  );

  const toggleVisibility = useCallback(
    field => setVisibility(prev => ({ ...prev, [field]: !prev[field] })),
    [],
  );

  return { visibility, toggleVisibility };
}
